const mobileNavPopoutElement = document.getElementById('navbarSupportedContent') as HTMLElement;

const handleDocumentClick = (event: Event) => {
  const target = event.target as HTMLElement;
  const isClickInsideNav = mobileNavPopoutElement.contains(target);

  if (!target.classList.contains('navbar-toggler') && !isClickInsideNav && mobileNavPopoutElement.classList.contains('show')) {
    $(mobileNavPopoutElement)
      .collapse('hide');
  }
};

const mobileNavObserver = new MutationObserver((mutationsList) => {
  mutationsList.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      if (mobileNavPopoutElement.classList.contains('show')) {
        document.addEventListener('click', handleDocumentClick);
        document.body.classList.add('showing-responsive-menu');
      } else {
        document.removeEventListener('click', handleDocumentClick);
        document.body.classList.remove('showing-responsive-menu');
      }
    }
  });
});

if (mobileNavPopoutElement !== null) {
  mobileNavObserver.observe(mobileNavPopoutElement, {
    attributes: true,
    attributeFilter: ['class'],
  });
}

const slidingMenuElements = document.querySelectorAll('.sliding-menu');

slidingMenuElements.forEach((slidingMenuElement) => {
  const slidingMenuObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (slidingMenuElement.classList.contains('show')) {
          document.body.classList.add('showing-sliding-menu');
        } else {
          document.body.classList.remove('showing-sliding-menu');
        }
      }
    });
  });

  slidingMenuObserver.observe(slidingMenuElement, {
    attributes: true,
    attributeFilter: ['class'],
  });

  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;
    if (
      slidingMenuElement.classList.contains('show')
      && !target.closest('.sliding-menu')
      && !target.closest('.sliding-menu-open')
    ) {
      slidingMenuElement.classList.remove('show');
    }
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 992 && slidingMenuElement.classList.contains('show')) {
      slidingMenuElement.classList.remove('show');
    }
  });
});
